import { DataField } from "@certn/cascadia-react";
import { ControlProps, UISchemaElement } from "@jsonforms/core";
import { JsonFormsDispatch, withJsonFormsControlProps } from "@jsonforms/react";

import { handleMissingAndBlankData, formatData } from "../utils";

function transformData(data: ControlProps["data"], format: string) {
  return handleMissingAndBlankData(formatData(data, format));
}

export function DataFieldControl(props: ControlProps) {
  if (!props.visible) {
    return null;
  }

  const elements = props.uischema.options?.detail?.elements || [];

  return (
    <DataField
      name={props.label}
      value={
        elements.length > 0 ? (
          <>
            {elements.map((elem: UISchemaElement, index: number) => {
              return (
                <JsonFormsDispatch
                  key={index}
                  schema={props.schema}
                  uischema={elem}
                  path={props.path}
                />
              );
            })}
          </>
        ) : (
          transformData(props.data, props.uischema.options?.format)
        )
      }
    />
  );
}

export const DataFieldControlRenderer =
  withJsonFormsControlProps(DataFieldControl);
